import { render, staticRenderFns } from "./eligibility-criteria.component.vue?vue&type=template&id=f3bf90de&"
import script from "./eligibility-criteria.component.ts?vue&type=script&lang=ts&"
export * from "./eligibility-criteria.component.ts?vue&type=script&lang=ts&"
import style0 from "./eligibility-criteria.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports